import { render } from "./New_CataloguerForm.vue?vue&type=template&id=0b329962&scoped=true"
import script from "./New_CataloguerForm.vue?vue&type=script&lang=js"
export * from "./New_CataloguerForm.vue?vue&type=script&lang=js"

import "./New_CataloguerForm.vue?vue&type=style&index=0&id=0b329962&scoped=true&lang=css"
import "./New_CataloguerForm.vue?vue&type=style&index=1&id=0b329962&lang=css"
import "./New_CataloguerForm.vue?vue&type=style&index=2&id=0b329962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b329962"]])

export default __exports__